import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Globe, LayoutDashboard, UserRound, Ticket, Users, LogOut, Share2, ShieldAlert, ShoppingCart, Crown, Cpu, Menu, X, Send, Mail } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/contexts/AuthContext";

const NAV = [
  { to: "/dashboard", label: "Kontrolna tabla", icon: LayoutDashboard, id: "nav-dashboard" },
  { to: "/profil", label: "Moj profil", icon: UserRound, id: "nav-profile" },
  { to: "/tokeni", label: "NAŠA Tokeni", icon: Ticket, id: "nav-tokens" },
  { to: "/ciklusi", label: "Ciklusi mašina", icon: Cpu, id: "nav-cycles" },
  { to: "/prijatelji", label: "Pozvani prijatelji", icon: Users, id: "nav-friends" },
  { to: "/pozovi", label: "Pozovi prijatelje", icon: Share2, id: "nav-invite" },
  { to: "/promoteri", label: "Najbolji promoteri", icon: Crown, id: "nav-leaderboard" },
  { to: "https://t.me/wemynetoghether", label: "Telegram kanal", icon: Send, id: "nav-telegram", external: true },
  { to: "https://docs.google.com/forms/d/e/1FAIpQLScX-7XfmdgtdRjxtdjltvkNLH1kXwZxIA47UECoAv0r-wxGqw/viewform?usp=send_form", label: "Kontaktirajte nas", icon: Mail, id: "nav-contact", external: true },
];

export default function MobileHeader() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const items = [...NAV];
  if (user?.role === "admin") {
    items.push({ to: "/admin", label: "Admin panel", icon: ShieldAlert, id: "nav-admin" });
  }

  const handleLogout = async () => {
    await logout();
    navigate("/prijava");
    setOpen(false);
  };

  return (
    <>
      <header className="md:hidden flex items-center justify-between px-4 py-3 border-b border-white/10 bg-[#050505] sticky top-0 z-40">
        <Logo size={40} withText />
        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="p-2 border border-white/20 text-white rounded-sm"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </header>

      {open && (
        <div className="md:hidden fixed inset-0 z-30 bg-black/90 backdrop-blur-sm pt-16">
          <nav className="px-4 py-6 space-y-1">
            {items.map((item) => (
              item.external ? (
                <a
                  key={item.to}
                  href={item.to}
                  data-testid={item.id}
                  onClick={() => setOpen(false)}
                  className="flex items-center gap-3 px-4 py-4 text-sm uppercase tracking-wider border-l-2 transition-all border-[#22ff77]/40 text-[#22ff77]"
                >
                  <item.icon className="w-5 h-5" strokeWidth={1.5} />
                  <span className="font-display font-semibold">{item.label}</span>
                </a>
              ) : (
                <NavLink
                  key={item.to}
                  to={item.to}
                  data-testid={item.id}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-4 text-sm uppercase tracking-wider border-l-2 transition-all ${
                      isActive
                        ? "border-[#22ff77] bg-[#22ff77]/5 text-[#22ff77]"
                        : "border-transparent text-zinc-400"
                    }`
                  }
                >
                  <item.icon className="w-5 h-5" strokeWidth={1.5} />
                  <span className="font-display font-semibold">{item.label}</span>
                </NavLink>
              )
            ))}
          </nav>

          <div className="px-4 pt-4 border-t border-white/10 mx-4">
            <div className="mb-4 px-2">
              <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500">Prijavljen kao</div>
              <div className="text-sm text-white truncate">{user?.name || user?.email}</div>
            </div>
            <button
              onClick={handleLogout}
              className="w-full flex items-center justify-center gap-2 py-3 border border-[#ff7a18]/40 text-[#ff7a18] hover:bg-[#ff7a18]/10 transition-all rounded-sm text-xs uppercase tracking-widest font-display font-semibold"
            >
              <LogOut className="w-4 h-4" strokeWidth={1.5} />
              Odjavi se
            </button>
          </div>
        </div>
      )}
    </>
  );
}
